import { FinishNewsletterPopupProps } from '@husky-x/cc-finish-newsletter-popup/dist/types/models';

export const FinishProductDifferencesMock = {
  header: '<h2>COMPAREZ NOTRE GAMME DE PRODUITS</h2>',
  borderedImage: true,
  navigationButton: {
    link: '/produits/',
    label: 'VOIR TOUS LES PRODUITS',
  },
  useCheckmark: false,
  tables: [
    {
      title: 'FINISH',
      legend:
        '<ul>\n<li><sup>*</sup>Avec un chargement lourd</li>\n<li><sup>**</sup>vs. Finish Power basé sur un poids moyen</li>\n<li><sup>***</sup>S’attaque même aux taches de brûlé</li>\n<li><sup>****</sup>Ingrédient : Enzyme</li>\n</ul>',
      rows: [
        {
          text: 'Propreté',
          image:
            'https://eu-images.contentstack.com/v3/assets/bltf66eb2ba30842434/blt95325f54ff3b2691/677d498721f2a7d51f507268/clean.svg',
        },
        {
          text: 'Brillance',
          image:
            'https://eu-images.contentstack.com/v3/assets/bltf66eb2ba30842434/bltafa7ad17332ebfe6/677d497d316bc689c570b59f/shine.svg',
        },
        {
          text: 'Taches incrustées depuis 48h<sup>*</sup>',
          image:
            'https://eu-images.contentstack.com/v3/assets/bltf66eb2ba30842434/blt427f1ac30520382a/677d497dbc3df478bb01825a/dried-on.svg',
        },
        {
          text: 'Taches de graisse',
          image:
            'https://eu-images.contentstack.com/v3/assets/bltf66eb2ba30842434/blt950c924190ffcdf1/677d497d4275ab45c9f74fd3/tough-on-grease.svg',
        },
        {
          text: 'Stop au pré-lavage',
          image:
            'https://eu-images.contentstack.com/v3/assets/bltf66eb2ba30842434/blt75f4cc52530b924c/677d497d6d31b7d49ac18b33/skip-the-rinse.svg',
        },
        {
          text: 'Capsules sans emballage individuel',
          image:
            'https://eu-images.contentstack.com/v3/assets/bltf66eb2ba30842434/bltfad731c0423da783/677d497dbc3df44d9e01825e/wrapper-free-tabs.svg',
        },
        {
          text: 'Dissolution rapide',
          image:
            'https://eu-images.contentstack.com/v3/assets/bltf66eb2ba30842434/blt8c48fa6e258c5b4a/677d497d43d191013e612a9d/fast-dissolving.svg',
        },
        {
          text: 'Avec moins d’ingrédients chimiques<sup>**</sup>',
          image:
            'https://eu-images.contentstack.com/v3/assets/bltf66eb2ba30842434/blt56d51174c45a4028/677d497d3bc87f276af2d957/less-chemical-weight.svg',
        },
        {
          text: 'Protection du verre',
          image:
            'https://eu-images.contentstack.com/v3/assets/bltf66eb2ba30842434/blt860880330d57f440/677d497dc9370ed91c228f4c/glass-protection.svg',
        },
        {
          text: 'Boost de fraîcheur',
          image:
            'https://eu-images.contentstack.com/v3/assets/bltf66eb2ba30842434/bltf6f70d0b55bebdf7/677d497dae5938983f3efced/freshness-boost.svg',
        },
        {
          text: 'Taches de brûlé<sup>***</sup>',
          image:
            'https://eu-images.contentstack.com/v3/assets/bltf66eb2ba30842434/bltabc5366ae9d06172/677d498743d1919c1c612aa1/burnt-on-stains.svg',
        },
        {
          text: 'Libération séquentielle des ingrédients<sup>****</sup>',
          image:
            'https://eu-images.contentstack.com/v3/assets/bltf66eb2ba30842434/bltc3b32ea6323d7bf6/677d497d21f2a7c550507264/right-ingredient-right-time-1.png',
        },
      ],
      columns: [
        {
          productImage:
            'https://eu-images.contentstack.com/v3/assets/bltf66eb2ba30842434/blt8c90908f9a077b97/677d4ac305945faedbe079d0/ultimate-plus-diff-group.png',
          productName: 'ULTIMATE PLUS',
          productLink: '/produits/detergents/ultimate-plus/',
          color: 'gold-gradient',
          values: [
            {
              value: 5,
            },
            {
              value: 4,
            },
            {
              value: 4,
            },
            {
              value: 1,
            },
            {
              value: 1,
            },
            {
              value: 1,
            },
            {
              value: 1,
            },
            {
              value: 1,
            },
            {
              value: 1,
            },
            {
              value: 1,
            },
            {
              value: 1,
            },
            {
              value: 1,
            },
          ],
        },
        {
          productImage:
            'https://eu-images.contentstack.com/v3/assets/bltf66eb2ba30842434/bltfbed24bef3f4af03/677d4ac3b6795546a087a6ef/ultimate-diff-group.png',
          productName: 'ULTIMATE',
          productLink: '/produits/detergents/ultimate/',
          color: 'black-gradient',
          values: [
            {
              value: 4,
            },
            {
              value: 4,
            },
            {
              value: 3,
            },
            {
              value: 1,
            },
            {
              value: 1,
            },
            {
              value: 1,
            },
            {
              value: 1,
            },
            {
              value: 1,
            },
            {
              value: 1,
            },
          ],
        },
        {
          productImage:
            'https://eu-images.contentstack.com/v3/assets/bltf66eb2ba30842434/blt2726ee1573cfee4e/677d4ac3c9370e310b228f54/quantum-diff-group.png',
          productName: 'QUANTUM',
          productLink: '/produits/detergents/quantum/',
          color: 'dark-blue-gradient',
          values: [
            {
              value: 3,
            },
            {
              value: 3,
            },
            {
              value: 2,
            },
            {
              value: 1,
            },
            {
              value: 1,
            },
            {
              value: 1,
            },
            {
              value: 1,
            },
            {
              value: 1,
            },
          ],
        },
        {
          productImage:
            'https://eu-images.contentstack.com/v3/assets/bltf66eb2ba30842434/blt2b8f37f18a6fd0c5/677d4ac3827b1f1ba4ab1e16/power-plus-diff-group.png',
          productName: 'POWER',
          productLink: '/produits/detergents/tablettes-tout-en-1-max/',
          color: 'blue-gradient',
          values: [
            {
              value: 2,
            },
            {
              value: 2,
            },
            {
              value: 1,
            },
            {
              value: 1,
            },
            {
              value: 1,
            },
            {
              value: 1,
            },
          ],
        },
      ],
    },
  ],
};

export const FinishProductCardsMock = {
  cards: [
    {
      productName: 'FINISH ULTIMATE',
      image:
        'https://eu-images.contentstack.com/v3/assets/bltf66eb2ba30842434/blt487bcdbb5adff662/677d4958d05c39108c47732b/ultimate.webp',
      cardStyle: 'dark-blue',
      button: {
        link: '/produits/detergents/ultimate/',
        text: 'DÉCOUVREZ ULTIMATE',
      },
      icons: [
        {
          src: 'https://eu-images.contentstack.com/v3/assets/bltf66eb2ba30842434/blt240271bd6e06aeea/677d4958d05c395685477329/tough-on-grease_(1).webp',
          name: 'EFFICACE SUR LES TACHES DE GRAISSE',
        },
        {
          src: 'https://eu-images.contentstack.com/v3/assets/bltf66eb2ba30842434/blt8d6ec9d6c6f17c7a/677d495821f2a7101750725f/dried-on-stains.webp',
          name: 'TACHES INCRUSTÉES DEPUIS <strong>48</strong>H<sup>i</sup>',
        },
      ],
      mobileOrder: 2,
    },
    {
      productName: 'FINISH ULTIMATE PLUS',
      primary: true,
      image:
        'https://eu-images.contentstack.com/v3/assets/bltf66eb2ba30842434/blt8fbcce6faeaf9ee3/677d4958c9370eaa68228f48/ultimate-plus.webp',
      cardStyle: 'black',
      button: {
        link: '/produits/detergents/ultimate-plus/',
        text: 'DÉCOUVREZ NOTRE MEILLEUR PRODUIT, ULTIMATE PLUS',
      },
      icons: [
        {
          src: 'https://eu-images.contentstack.com/v3/assets/bltf66eb2ba30842434/blt740edc1f8ca4a991/677d4958981acb8ea0d2e5df/extra-cleaning-power.webp',
          name: '<strong>3X</strong> PLUS D’ACTIFS NETTOYANTS<sup>ii</sup>',
          styleType: 'text-on-image',
        },
        {
          src: 'https://eu-images.contentstack.com/v3/assets/bltf66eb2ba30842434/blt99066892f4cfafa6/677d495837fb04379cab90d4/tough-on-grease-gold.webp',
          name: 'EFFICACE SUR LES TACHES DE GRAISSE',
        },
        {
          src: 'https://eu-images.contentstack.com/v3/assets/bltf66eb2ba30842434/bltb648038158f93af4/677d4958d05c395b81477323/burnt-on-stains.webp',
          name: 'TACHES DE BRÛLÉ<sup>iii</sup>',
        },
      ],
      mobileOrder: 1,
    },
    {
      productName: 'FINISH QUANTUM',
      image:
        'https://eu-images.contentstack.com/v3/assets/bltf66eb2ba30842434/blte3131f28cd7b5f4f/677d49584275ab88def74fce/quantum.webp',
      cardStyle: 'light-blue',
      button: {
        link: '/produits/detergents/quantum/',
        text: 'DÉCOUVREZ QUANTUM',
      },
      icons: [
        {
          src: 'https://eu-images.contentstack.com/v3/assets/bltf66eb2ba30842434/blt240271bd6e06aeea/677d4958d05c395685477329/tough-on-grease_(1).webp',
          name: 'EFFICACE SUR LES TACHES DE GRAISSE',
        },
      ],
      mobileOrder: 3,
    },
  ],
};

export const FinishNewsletterPopupMock: FinishNewsletterPopupProps = {
  headline: '15% DE REDUCTION SUR NOTRE GAMME ULTIMATE PLUS',
  description:
    'Inscrivez-vous et profitez d’une réduction sur notre meilleure gamme de capsules FINISH ULTIMATE PLUS.',
  image: {
    src: 'https://eu-images.contentstack.com/v3/assets/bltf66eb2ba30842434/bltc720e55267990134/67a475e02109c14f91a42b79/ultimate-plus-73-regular.webp',
    mobileSrc:
      'https://eu-images.contentstack.com/v3/assets/bltf66eb2ba30842434/bltc720e55267990134/67a475e02109c14f91a42b79/ultimate-plus-73-regular.webp',
    alt: 'finish',
  },
  thankYou: {
    headline: 'Vous pouvez dès maintenant utiliser votre code de réduction sur Amazon',
    description: 'Votre code: FINISH15',
    closeButton: {
      label: 'Fermer',
      redirectUrl: '/',
    },
  },
  form: {
    id: 'e33539ab-0824-4a9f-a99c-4450f26fe47d',
    url: 'https://phx-promoplatform-api-pl-prod.promoplatform.rbcloud.io/api/v1/external/forms',
    submitErrorMessage: 'veuillez remplir le champ',
  },
};

export const FinishImageMapDropMock = {
  map: [
    {
      shape: 'poly',
      coords: '238,2,197,90,213,126,255,137,281,98',
      alt: 'Approx 10% de la consommation moyenne des menages',
      tooltip: '',
      activeState: {
        url: 'https://eu-images.contentstack.com/v3/assets/bltf66eb2ba30842434/blta05b8ba24b87dd38/693be8223099acb1f7a21932/droplet_fr-1.png',
      },
    },
    {
      shape: 'poly',
      coords:
        '288,151,277,184,269,203,254,224,243,246,243,276,257,297,276,309,308,302,329,285,337,263,334,239',
      alt: 'environ 12% de la consommation moyenne des menages',
      tooltip: '',
      activeState: {
        url: 'https://eu-images.contentstack.com/v3/assets/bltf66eb2ba30842434/blt70dc28f7f5375e18/693be8229f17d135f9c95a01/droplet_fr-3.png',
      },
    },
    {
      shape: 'poly',
      coords:
        '162,241,164,258,163,282,163,304,163,328,162,354,171,379,187,393,202,402,224,404,250,397,265,382,274,361,272,341,257,319',
      alt: 'environ 20% de la consommation moyenne des menages',
      tooltip: '',
      activeState: {
        url: 'https://eu-images.contentstack.com/v3/assets/bltf66eb2ba30842434/blt03cdb8097aefc229/693be8220a59ed26c92f6d36/droplet_fr-4.png',
      },
    },
    {
      shape: 'poly',
      coords:
        '343,217,349,238,350,253,350,282,342,309,330,326,317,342,303,351,281,378,273,404,273,436,281,453,307,482,329,494,369,491,407,477,429,451,440,408,427,346,396,283',
      alt: 'environ 39% de la consommation moyenne des menages',
      tooltip: '',
      activeState: {
        url: 'https://eu-images.contentstack.com/v3/assets/bltf66eb2ba30842434/bltfe7753bfe5bab9dd/693be8229956f18d648ecb61/droplet_fr-5.png',
      },
    },
    {
      shape: 'poly',
      coords:
        '107,238,97,248,82,265,59,292,43,323,25,351,10,395,2,437,6,471,23,494,48,517,67,524,118,526,149,505,163,489,180,447,159,398,126,368,109,340,95,298',
      alt: 'environ 6% de la consommation moyenne des menages',
      tooltip: '',
      activeState: {
        url: 'https://eu-images.contentstack.com/v3/assets/bltf66eb2ba30842434/blt25c28c0b50df023b/693be8221994708d8cce11d8/droplet_fr-6.png',
      },
    },
    {
      shape: 'poly',
      coords:
        '189,110,185,126,177,149,164,179,161,208,165,223,181,238,199,246,224,240,245,227,245,204',
      alt: 'environ 7% de la consommation moyenne des menages',
      tooltip: '',
      activeState: {
        url: 'https://eu-images.contentstack.com/v3/assets/bltf66eb2ba30842434/blta1528a0ede2da600/693be82267273bfc2535cc8c/droplet_fr-2.png',
      },
    },
  ],
};
